/**
 * Checks if a string is valid JSON
 * @param raw - The string to validate
 * @returns true if valid JSON, false otherwise
 */
export const isJsonValid = (raw: string): boolean => {
  try {
    JSON.parse(raw);

    return true;
  } catch {
    return false;
  }
};

export const prettifyJson = (raw: unknown): string =>
  JSON.stringify(raw, null, 2);
